angular.module('gym.components').directive('trainerAvailability', function() {
  return {
    restrict: 'E',
    template: require('templates/components/profile/trainerAvailability.html.slim'),
    scope: {
      profile: '='
    },
    controller: ["$scope", "$rootScope", "$stateParams", "$document", "loadingAnimation", "Availability", "EditAvailabilityService", "EmploymentService", function($scope, $rootScope, $stateParams, $document, loadingAnimation, Availability, EditAvailabilityService, EmploymentService) {
      var createAvailability, getAvailabilityBlocks, renderTrainerEvents;
      $scope.permissions = EmploymentService.get().permissions;
      $scope.uiConfig = {
        calendar: {
          editable: false,
          allDayDefault: false,
          allDaySlot: false,
          lazyFetching: false,
          defaultView: 'agendaWeek',
          loading: function(isLoading) {
            if (isLoading) {
              return loadingAnimation.show();
            } else {
              return loadingAnimation.hide();
            }
          },
          header: null,
          firstDay: $rootScope.gym.gym_booking_detail.calendar_start_wday,
          timeFormat: {
            day: 'h:mmt{ - h:mmt}',
            basicDay: 'h:mmt{ - h:mmt}'
          },
          eventAfterAllRender: function(view) {
            return $scope.calendarView = view;
          },
          eventRender: function(data, element) {
            return renderTrainerEvents(data, element);
          },
          dayClick: function(date, allDay, event, sourceView) {
            var container, coords;
            if (!$scope.canManageAvailability()) {
              return;
            }
            container = angular.element('.js-profile-container')[0];
            coords = container.getBoundingClientRect();
            return $scope.calendarItemOptions = {
              left: event.pageX - coords.x,
              top: event.pageY - 130,
              date: moment(date).format('YYYY-MM-DD'),
              start_time_obj: date,
              end_time_obj: moment(date).add(1, 'hours').toDate()
            };
          },
          eventClick: function(data, event) {
            var container, coords;
            if (!$scope.canManageAvailability()) {
              return;
            }
            container = angular.element('.js-profile-container')[0];
            coords = container.getBoundingClientRect();
            return $scope.calendarItemOptions = {
              left: event.pageX - coords.x,
              top: event.pageY - 145,
              slot: data
            };
          }
        }
      };
      $scope.toDate = function(date) {
        return $scope.calendarView.calendar.gotoDate(date.toDate());
      };
      $scope.getTitle = function() {
        var ref, title;
        title = (ref = $scope.calendarView) != null ? ref.title : void 0;
        if (title) {
          return title.replace('&#8212;', '—');
        }
      };
      $scope.eventSources = [
        {
          events: function(start,
        end,
        callback) {
            var endDate,
        params,
        startDate;
            $scope.startDate = moment(start);
            startDate = moment(start).subtract(1,
        'days').format('YYYY-MM-DD');
            endDate = moment(end).add(1,
        'days').format('YYYY-MM-DD');
            params = {
              'filters[user_id]': $stateParams.userId || window.currentUser.id,
              'filters[include_events]': true,
              'filters[start_date]': startDate,
              'filters[end_date]': endDate,
              'count': 1000,
              '_': new Date().getTime()
            };
            return Availability.getList(params).then(function(data) {
              var collection;
              collection = data.plain().map(function(item) {
                item.id = item.trainer_availability_block_id;
                item.start = item.start_at;
                item.start_time_obj = moment(item.start_time,
        'Hmm').toDate();
                item.end = item.end_at;
                item.end_time_obj = moment(item.end_time,
        'Hmm').toDate();
                item.title = item.location_name;
                return item;
              });
              $scope.availabilityCollection = collection;
              return callback(collection);
            });
          }
        }
      ];
      renderTrainerEvents = function(data, element) {
        var availabilityContainer, trainerEvents;
        availabilityContainer = $(element).find('.fc-event-inner');
        $(element).addClass("available-time");
        trainerEvents = '<ul class="trainer-bookings">' + data.events_with_bookings.map(function(event) {
          var time;
          time = moment(event.start_at, 'YYYY/MM/DD HH:mm').format('HH:mm');
          return `<li class='trainer-bookings__item'>${time} ${event.name}</li>`;
        }).join('') + '</ul>';
        return availabilityContainer.append(trainerEvents);
      };
      $scope.addNewAvailability = function(isRecurring) {
        var availabilityBlocks, date, newAvailability;
        date = $scope.calendarItemOptions.date;
        newAvailability = EditAvailabilityService.getNewAvailabilityBlock($scope.calendarItemOptions.start_time_obj, $scope.calendarItemOptions.end_time_obj);
        availabilityBlocks = [newAvailability].concat(getAvailabilityBlocks(date));
        return createAvailability(isRecurring, date, availabilityBlocks);
      };
      $scope.editAvailability = function(isRecurring) {
        var availabilityBlocks, date;
        date = $scope.calendarItemOptions.slot.availability_date;
        availabilityBlocks = getAvailabilityBlocks(date);
        return createAvailability(isRecurring, date, availabilityBlocks);
      };
      $scope.deleteAvailability = function(isRecurring) {
        var blocks, slot;
        if (window.confirm("Are you sure you want to delete this availability?")) {
          slot = $scope.calendarItemOptions.slot;
          $scope.calendarItemOptions = void 0;
          blocks = getAvailabilityBlocks(slot.availability_date);
          return EditAvailabilityService.removeAvailability(isRecurring, slot, blocks).then(function() {
            return $scope.calendarView.calendar.refetchEvents();
          });
        }
      };
      createAvailability = function(isRecurring, date, availabilityBlocks) {
        var editType;
        $document.scrollTop(0);
        editType = isRecurring ? 'recurring' : 'single';
        $scope.calendarItemOptions = void 0;
        return $scope.trainerAvailability = {
          user_id: $stateParams.userId || window.currentUser.id,
          current_date: date,
          edit_type: editType,
          trainer_availability_blocks: availabilityBlocks
        };
      };
      getAvailabilityBlocks = function(date) {
        return _.where($scope.availabilityCollection, {
          availability_date: date
        });
      };
      $scope.showAvailability = function() {
        $document.scrollTop(0);
        return $scope.trainerAvailability = void 0;
      };
      $scope.isCurrentUser = function() {
        return $scope.profile.id === window.currentUser.id;
      };
      return $scope.canManageAvailability = function() {
        return $scope.isCurrentUser() || $scope.permissions.manage_other_trainers_availability;
      };
    }]
  };
});
